export default __webpack_public_path__ + "static/selectlanguage-snapshot-e002a95ba86dc44a1d56b9c240cc867e.jpg";